<template>
  <div class="flex w-full items-center justify-center pb-16 lg:gap-6">
    <div
      class="flex w-full transform-gpu flex-col gap-4 transition-none lg:max-w-[900px] lg:transition-all lg:duration-500 lg:ease-in-out"
      :class="
        selectedTable === 'positive' ? 'z-20' : 'absolute z-10 translate-x-[-920px] scale-90 opacity-50 blur-sm filter'
      "
    >
      <div class="flex w-full items-center justify-between">
        <h3 class="text-lg text-gray-500 dark:text-gray-400 lg:text-2xl">
          Relação risco-retorno
          <span class="font-bold uppercase text-gray-300"> maior que um </span>
        </h3>
        <button
          @click="switchTables"
          class="bg-ontick-blue-600 flex h-8 min-w-[32px] items-center justify-center rounded-full lg:hidden"
        >
          <i v-html="$icons.chevron_right"></i>
        </button>
      </div>
      <ranking-list-component
        :selectedIndex="setSelectedItem('positive')"
        :class="{ 'pointer-events-none': selectedTable === 'negative' }"
        v-if="data && data.ranking_1"
        :data="data.ranking_1.ranking_data"
        @open-details="openDetails"
      />
      <p class="text-xs text-gray-500 dark:text-gray-400" v-if="data && data.ranking_1">
        Última atualização:
        <span>
          {{ data.ranking_1.start_time }}
        </span>
      </p>
    </div>
    <div
      class="flex w-full transform-gpu flex-col gap-4 transition-none lg:max-w-[900px] lg:transition-all lg:duration-500 lg:ease-in-out"
      :class="
        selectedTable === 'positive' ? 'absolute z-10 translate-x-[920px] scale-90 opacity-50 blur-sm filter' : 'z-20'
      "
    >
      <div class="flex w-full items-center justify-between">
        <h3 class="text-lg text-gray-500 dark:text-gray-400 lg:text-2xl">
          Relação risco-retorno
          <span class="font-bold uppercase text-gray-300"> menor que um </span>
        </h3>
        <button
          @click="switchTables"
          class="bg-ontick-blue-600 flex h-8 min-w-[32px] items-center justify-center rounded-full lg:hidden"
        >
          <i v-html="$icons.chevron_right"></i>
        </button>
      </div>
      <ranking-list-component
        :selectedIndex="setSelectedItem('negative')"
        :class="{ 'pointer-events-none': selectedTable === 'positive' }"
        v-if="data && data.ranking_2"
        :data="data.ranking_2.ranking_data"
        @open-details="openDetails"
      />
      <p class="text-xs text-gray-500 dark:text-gray-400" v-if="data && data.ranking_2">
        Última atualização:
        <span>
          {{ data.ranking_2.start_time }}
        </span>
      </p>
    </div>
    <!-- <div class="absolute inset-0 z-10 hidden lg:block"> -->
    <button
      v-if="selectedTable === 'negative'"
      @click="switchTables"
      class="absolute top-0 left-0 z-30 flex h-full flex-col items-center justify-center gap-2 px-4 filter transition-all ease-in-out hover:brightness-125"
    >
      <div class="rounded-md-full flex h-10 w-10 rotate-180 transform-gpu items-center justify-center">
        <i v-html="$icons.chevron_lg_right" class="text-ontick-blue-600 drop-shadow-lg filter"></i>
      </div>
      <span class="sr-only"> Risco-retorno positivo </span>
    </button>
    <button
      v-if="selectedTable === 'positive'"
      @click="switchTables"
      class="absolute top-0 right-0 z-30 flex h-full flex-col items-center justify-center gap-2 px-4 filter transition-all ease-in-out hover:brightness-125"
    >
      <div
        class="rounded-md-full flex h-10 w-10 items-center justify-center"
        :class="{ '': selectedTable === 'negative' }"
      >
        <i v-html="$icons.chevron_lg_right" class="text-ontick-blue-600 drop-shadow-lg filter"></i>
      </div>
      <span class="sr-only"> Risco-retorno negativo </span>
    </button>
    <!-- </div> -->
    <ontick-aero :active="detailsIsActive" @close="closeDetails">
      <product-component
        v-if="detailsIsActive"
        :strategy_id="details.strategy"
        :product_id="details.product"
        :marketplace_status="details.marketplace_status"
        :active="detailsIsActive"
        :pagination="pagination"
        :index_last="lastIndex"
        @pagination="navigate"
        @close="closeDetails"
      />
    </ontick-aero>
    <portal to="modal">
      <ontick-modal
        :open="subscribeModalIsActive"
        @close="subscribeModalIsActive = false"
        size="small"
        :showCloseButton="false"
      >
        <subscription-modal-component :strategyInfo="subscriptionInfo" :planData="subscriptionPlans" />
      </ontick-modal>
    </portal>
  </div>
</template>

<script>
import ProductComponent from "../../marketplace/pages/details/product.component.vue";

import marketplaceAddComponent from "../../marketplace/components/products/card/marketplace-add.component.vue";
import SubscriptionModalComponent from "./subscription-modal.component.vue";
import RankingListComponent from "./ranking-list.component.vue";
import OntickSwitchComponent from "../../../shared/components/basic/ontick-switch.component.vue";
export default {
  components: {
    marketplaceAddComponent,
    ProductComponent,
    SubscriptionModalComponent,
    RankingListComponent,
    OntickSwitchComponent,
  },

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      result: "gain", // gain, loss
      selectedTable: "positive",
      trades: {
        positive: [],
        negative: [],
      },
      detailsIsActive: false,
      subscribeModalIsActive: false,
      subscriptionInfo: {},
      subscriptionPlans: [],
      pagination: undefined,
    };
  },

  computed: {
    details() {
      const { product_id, strategy_id } =
        this.data[this.selectedTable === "negative" ? "ranking_2" : "ranking_1"].ranking_data[this.pagination];
      return {
        product: product_id,
        strategy: strategy_id,
      };
    },
    lastIndex() {
      return this.data[this.selectedTable === "negative" ? "ranking_2" : "ranking_1"].ranking_data.length - 1;
    },
  },

  methods: {
    setSelectedItem(selectedTable) {
      if (this.selectedTable !== selectedTable || !this.detailsIsActive) return;
      return this.pagination;
    },
    closeDetails() {
      this.detailsIsActive = false;
    },
    navigate(event) {
      switch (event) {
        case "previous":
          if (this.pagination === 0) return;
          this.pagination--;
          break;
        case "next":
          if (this.pagination >= this.lastIndex) return;
          this.pagination++;
          break;
      }
    },
    switchTables() {
      if (this.selectedTable === "positive") {
        this.selectedTable = "negative";
      } else {
        this.selectedTable = "positive";
      }
    },
    subscribe(strategy) {
      this.subscriptionInfo = strategy;
      this.subscribeModalIsActive = true;
    },
    openDetails(index) {
      this.pagination = index;
      this.detailsIsActive = true;
    },
    switchTables() {
      if (this.selectedTable === "positive") {
        this.selectedTable = "negative";
      } else {
        this.selectedTable = "positive";
      }
    },
    textTooltip(status) {
      const tooltips = {
        ADDED: "Você já adicionou este investimento",
        HIDDEN: "Este investimento está em sua lista de arquivados",
        default: "Adicione agora esta estratégia aos seus investimentos",
      };
      return tooltips[status] || tooltips.default;
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  @apply flex w-[85px] flex-col items-end py-2 text-right last-of-type:mr-4 last-of-type:w-[150px];
  dt {
    @apply text-xs text-gray-500 dark:text-gray-400;
  }
  dd {
    @apply font-bold;
  }
}
</style>
